/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'calendar-confirmed': {
    width: 18,
    height: 17,
    viewBox: '0 0 18 17',
    data: '<path pid="0" d="M6.252 11.387c-.3-.328-.277-.848.055-1.184a.84.84 0 011.165.055l1.258 1.367 2.51-2.723a.823.823 0 011.171-.048c.344.324.367.854.047 1.179l-3.12 3.37a.8.8 0 01-.608.284.803.803 0 01-.603-.278l-1.875-2.022zm7.28-10.102h2.166c1.16 0 2.11.955 2.11 2.117V14.44c0 1.176-.946 2.134-2.11 2.134H2.91C1.745 16.574.8 15.616.8 14.44V3.42c0-1.176.945-2.134 2.11-2.134h2.182V.831c0-.454.372-.831.823-.831.452 0 .824.377.824.831v.454h5.146V.831c0-.454.372-.831.824-.831.452 0 .823.377.823.831v.454zm2.611 4.243V3.402a.467.467 0 00-.462-.455h-2.165v.455a.832.832 0 01-.823.83.832.832 0 01-.824-.83v-.455H6.722v.455a.832.832 0 01-.824.83.832.832 0 01-.823-.83v-.455H2.91a.456.456 0 00-.463.455v2.126h13.696zm0 1.68H2.447v7.214c0 .245.213.455.462.455h12.788c.215 0 .392-.14.446-.33V7.207z" _fill="#213F6B" fill-rule="nonzero"/>'
  }
})
